// src/components/ChatSound/ChatSound.js
import { useEffect } from "react";
import { getUnlockedAudioContext, installAudioUnlockListener } from "./ShareAudio";

const ChatSound = ({ play, audioSrc, onFinish }) => {
  useEffect(() => installAudioUnlockListener(), []);

  useEffect(() => {
    if (!play || !audioSrc) return;

    let cancelled = false;
    let source;

    const playSound = async () => {
      const ctx = getUnlockedAudioContext();
      if (!ctx) {
        // No unlocked context yet – can't play, but no error
        if (onFinish) onFinish();
        return;
      }

      try {
        const arrayBuf = await fetch(audioSrc).then((res) => res.arrayBuffer());
        const decoded = await new Promise((resolve, reject) => {
          ctx.decodeAudioData(arrayBuf, resolve, reject);
        });

        if (cancelled) return;

        source = ctx.createBufferSource();
        source.buffer = decoded;
        source.connect(ctx.destination);

        source.onended = () => {
          if (!cancelled && onFinish) onFinish();
        };

        source.start(0);
      } catch (err) {
        console.error("[Sound] play error:", err);
        if (onFinish) onFinish();
      }
    };

    playSound();

    return () => {
      cancelled = true;
      if (source) {
        try {
          source.stop();
        } catch (_) { }
        source.disconnect();
      }
    };
  }, [play, audioSrc, onFinish]);

  return null;
};

export default ChatSound;
